/**
 * @file RoutingComponent.js
 * @description Centralized routing configuration for the application. Defines all accessible routes and their respective components.
 * @author 
 * @date 
 */

import React from 'react';
import { Route, Routes } from 'react-router-dom';

// Page components
import INCSUBDashboard from './pages/Dashboard';
import INCSUBLoginPage from './pages/login/LoginPage';
import INCSUBForgotPass from './pages/login/forgotPass/ForgotPass';
import INCSUBHomeScreen from './pages/HomeScreen';

/**
 * @function RoutingComponent
 * @description Handles route mapping for the entire application based on URL paths.
 * @returns {JSX.Element}
 */
function RoutingComponent() {
    // Retrieve user role from local storage to determine access (currently unused, but logged)
    const path = JSON.parse(window.localStorage.getItem('userData'))?.userRole;
  

    return (
        <Routes>
            {/* Authentication routes */}
            <Route path="/login" Component={INCSUBLoginPage} />
            <Route path="/account/forgot_password" Component={INCSUBForgotPass} />

            {/* Dashboard routes based on user roles */}
            <Route path="/Superadmin" Component={INCSUBDashboard} />
            <Route path="/Admin" Component={INCSUBDashboard} />
            <Route path="/Contentmanager" Component={INCSUBDashboard} />
            <Route path="/Supportmanager" Component={INCSUBDashboard} />

            {/* Public route */}
            <Route path="/" Component={INCSUBHomeScreen} />
        </Routes>
    );
}

export default RoutingComponent;
